import { HistoryContent } from 'types';
import { formatTimestamp } from 'helpers/date';

interface Props {
  list: HistoryContent[];
  date: Date;
  content: JSX.Element;
}

export function addToHistoryList({
  list,
  date,
  content,
}: Props): HistoryContent[] {
  const newList = [...list];

  const { formattedDate } = formatTimestamp(date);

  const foundedDay = newList.find((entry) => {
    const { formattedDate: entryFormattedDate } = formatTimestamp(entry.date);

    return entryFormattedDate === formattedDate;
  });

  if (foundedDay) {
    foundedDay.entries.push({ date, content });
  } else {
    newList.push({ date, entries: [{ date, content }] });
  }

  return newList;
}
